import React from 'react';
import classnames from 'classnames';
import BaseStatusTag, { IBaseStatusTagProps } from '../BaseStatusTag';
import { StaticGatereviewDecisionsCodes, STATIC_GATEREVIEW_DECISIONS_CODES } from '@gp/constants/const';

import type { IRecord } from '@gp/types/global';
import type { IStatusTagCfg } from '../../types';

import './index.scss';

import PASS_ICON from '@gp/assets/svg/goG/go.svg';
import FAIL_ICON from '@gp/assets/svg/goG/noGo.svg';
import REDO_ICON from '@gp/assets/svg/goG/icon-revert.svg';
import PENDING_APPROVAL__ICON from '@gp/assets/svg/goG/icon-shalou.svg';

interface IGRStatusTagProps extends Omit<IBaseStatusTagProps, 'statusList' | 'statusMapping' | 'getStatusClassNames'> {}

const GR_STATUS_MAPPING: IRecord<IStatusTagCfg> = {
  [StaticGatereviewDecisionsCodes.Pass]: {
    text: 'Pass',
    icon: PASS_ICON,
  },
  [StaticGatereviewDecisionsCodes.Fail]: {
    text: 'Fail',
    icon: FAIL_ICON,
  },
  [StaticGatereviewDecisionsCodes.Redo]: {
    text: 'Redo',
    icon: REDO_ICON,
  },
  [StaticGatereviewDecisionsCodes.AwaitingApproval]: {
    text: 'Pending Approval',
    icon: PENDING_APPROVAL__ICON,
  },
};

const getStatusClassNames = (isTag: boolean, status: string): IRecord<boolean> => ({
  'dbg-gr-status-tag-pass': status === StaticGatereviewDecisionsCodes.Pass,
  'dbg-gr-status-tag-cancel': status === StaticGatereviewDecisionsCodes.Fail,
  'dbg-gr-status-tag-redo': status === StaticGatereviewDecisionsCodes.Redo,
  'dbg-gr-status-tag-pending-approval': status === StaticGatereviewDecisionsCodes.AwaitingApproval,
});

const GRStatusTag: React.FC<IGRStatusTagProps> = (props) => {
  const { className, status, ...restProps } = props;

  if (status === StaticGatereviewDecisionsCodes.Empty) return null;
  return (
    <BaseStatusTag
      {...restProps}
      className={classnames('dbg-gr-status-tag', className)}
      status={status}
      statusList={STATIC_GATEREVIEW_DECISIONS_CODES as any[]}
      statusMapping={GR_STATUS_MAPPING}
      getStatusClassNames={getStatusClassNames}
    />
  );
};

export default GRStatusTag;
